import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';
import { PremiumServiceMeta } from '../_models';

@Injectable({ providedIn: 'root' })
export class PremiumService {
    constructor(private http: HttpClient) { }

    getAllMetas(): Observable<BaseResponse> {
      return this.http.get(`${environment.apiUrl}/premium-service/metas`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addMeta(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/premium-service/meta/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateMeta(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/premium-service/meta/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteMeta(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/premium-service/meta/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getMeta(id: any): Observable<PremiumServiceMeta> { //detail
      return this.http.get(`${environment.apiUrl}/premium-service/meta/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new PremiumServiceMeta().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    listMetas(filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/premium-service/meta/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, PremiumServiceMeta);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

}
